export const useUserUpdatesLoading = () => useState('useUserUpdatesLoading', () => false)
export const useUserUpdatesNotifications = () => useState('useUserUpdatesNotifications', () => false)
export const useUserUpdatesChat = () => useState('useUserUpdatesChat', () => false)

